import type { Language } from './types';

const dictionaries = {
	en: {
		loading: 'Loading game…',
		unavailable: 'This game is not ready',
		tryAgain: 'Try again',
		name: 'Your name',
		continue: 'Continue',
		back: 'Back',
		confirmTitle: 'Is this information correct?',
		confirmName: 'Name',
		email: 'Email',
		edit: 'Edit',
		start: 'Start game',
		submit: 'Submit answer',
		next: 'Next question',
		correct: 'Correct!',
		incorrect: 'Not quite',
		hint: 'Hint',
		attemptsLeft: 'Attempts remaining',
		retryAnswer: 'Not quite. Try again.',
		timeExpired: "Time's up.",
		secondsShort: 'Sec',
		points: 'Points',
		headerLogin: 'Login',
		headerSurvey: 'Survey',
		headerInstructions: 'Instructions',
		headerCategory: 'Category',
		headerReveal: 'Reveal',
		headerBingo: 'Bingo',
		headerCategoryClash: 'Category Clash',
		headerLeaderboard: 'Leaderboard',
		question: 'Question',
		of: 'of',
		selectCategory: 'Choose a category',
		revealCategory: 'Reveal a category',
		yourCategory: 'Your category is',
		revealQuestion: 'Reveal question',
		answerQuestion: 'Answer Question',
		flipCardTitle: 'Flip a Card to see the category',
		flipCardHelp: 'Each card hides a category. Choose wisely.',
		spinCategoryTitle: 'Spin for a Category',
		spinCategoryHelp: 'Spin the wheel to reveal your trivia category.',
		pullCategoryTitle: 'Pull for a Category',
		pullCategoryHelp: 'Spin the drum to reveal your trivia category.',
		tapSpinCategory: 'Tap spin to reveal your category',
		spin: 'Spin',
		category: 'Category',
		chooseValue: 'Choose an available point value in this category.',
		continueRound: 'Continue playing',
		endGame: 'End game',
		submitScoreEndGame: 'Submit Score & End Game',
		endConfirm: 'Finish Category Clash with your current score?',
		bingo: 'Bingo!',
		submitBingo: 'Submit Bingo',
		submitBingoConfirm: 'Finish this Bingo board with final score of {score}?',
		bonusPoints: 'Bonus Points',
		bonusEarned: 'Bonus points earned:',
		bonusRules: 'Bonus:',
		perWinningPattern: 'per winning pattern',
		fullBoardBonus: 'full-board bonus',
		bingoStreakBonusRule: 'Streak bonus: 2× points for the second consecutive correct answer, 3× for the third, increasing by 1×.',
		keepPlaying: 'Keep playing',
		answered: 'Answered',
		correctStat: 'Correct',
		finalScore: 'Final score',
		correctAnswers: 'Correct answers',
		completionTime: 'Completion time',
		leaderboard: 'Leaderboard',
		playAgain: 'Play again',
		done: 'Done',
		home: 'Home',
		homeConfirm: 'Return Home? This attempt will not be saved.',
		bingoHomeConfirm: 'Return home with a final score of {score}?',
		returnHome: 'Return home',
		rank: 'Rank',
		player: 'Player',
		score: 'Score',
		survey: 'A few questions before you play',
		required: 'This field is required.',
		validEmail: 'Enter a valid email address.',
		videoLoading: 'Loading video…',
		videoReveal: 'Watch the video first. The question will appear in',
		videoError: 'The video could not be loaded.',
		retryVideo: 'Retry video',
		secondsLong: 'seconds.',
		selectAll: 'Select every correct answer.',
		rankHelp: 'Use the arrows or drag the choices into the correct order.',
		moveUp: 'Move up',
		moveDown: 'Move down',
		trueLabel: 'True',
		falseLabel: 'False',
		chooseOne: 'Choose one',
		iAgree: 'I agree to the',
		termsConditions: 'Terms & Conditions',
		viewDetails: 'View Details',
		consentDetails: 'Consent Details',
		close: 'Close',
		bingoHelp: 'Choose a square. Correct answers mark the board.',
		noResults: 'No completed results yet.',
		streak: 'streak',
		correctAnswer: 'Correct answer',
	},
	es: {
		loading: 'Cargando juego…',
		unavailable: 'Este juego no está listo',
		tryAgain: 'Intentar de nuevo',
		name: 'Tu nombre',
		continue: 'Continuar',
		back: 'Atrás',
		confirmTitle: '¿Esta información es correcta?',
		confirmName: 'Nombre',
		email: 'Correo electrónico',
		edit: 'Editar',
		start: 'Comenzar juego',
		submit: 'Enviar respuesta',
		next: 'Siguiente pregunta',
		correct: '¡Correcto!',
		incorrect: 'No exactamente',
		hint: 'Pista',
		attemptsLeft: 'Intentos restantes',
		retryAnswer: 'No exactamente. Inténtalo de nuevo.',
		timeExpired: 'Se acabó el tiempo.',
		secondsShort: 'Seg',
		points: 'Puntos',
		headerLogin: 'Acceso',
		headerSurvey: 'Encuesta',
		headerInstructions: 'Instrucciones',
		headerCategory: 'Categoría',
		headerReveal: 'Revelar',
		headerBingo: 'Bingo',
		headerCategoryClash: 'Category Clash',
		headerLeaderboard: 'Clasificación',
		question: 'Pregunta',
		of: 'de',
		selectCategory: 'Elige una categoría',
		revealCategory: 'Revelar una categoría',
		yourCategory: 'Tu categoría es',
		revealQuestion: 'Revelar pregunta',
		answerQuestion: 'Responder pregunta',
		flipCardTitle: 'Voltea una carta para ver la categoría',
		flipCardHelp: 'Cada carta esconde una categoría. Elige sabiamente.',
		spinCategoryTitle: 'Gira para obtener una categoría',
		spinCategoryHelp: 'Gira la rueda para revelar tu categoría de trivia.',
		pullCategoryTitle: 'Tira para obtener una categoría',
		pullCategoryHelp: 'Gira el tambor para revelar tu categoría de trivia.',
		tapSpinCategory: 'Toca Girar para revelar tu categoría',
		spin: 'Girar',
		category: 'Categoría',
		chooseValue: 'Elige un valor de puntos disponible en esta categoría.',
		continueRound: 'Seguir jugando',
		endGame: 'Terminar juego',
		submitScoreEndGame: 'Enviar puntuación y terminar',
		endConfirm: '¿Terminar Category Clash con tu puntuación actual?',
		bingo: '¡Bingo!',
		submitBingo: 'Enviar Bingo',
		submitBingoConfirm: '¿Terminar este tablero de Bingo con una puntuación final de {score}?',
		bonusPoints: 'Puntos extra',
		bonusEarned: 'Puntos extra obtenidos:',
		bonusRules: 'Bonificación:',
		perWinningPattern: 'por patrón ganador',
		fullBoardBonus: 'bonificación por tablero completo',
		bingoStreakBonusRule: 'Bonificación por racha: 2× puntos por la segunda respuesta correcta consecutiva, 3× por la tercera, aumentando 1× cada vez.',
		keepPlaying: 'Seguir jugando',
		answered: 'Respondidas',
		correctStat: 'Correctas',
		finalScore: 'Puntuación final',
		correctAnswers: 'Respuestas correctas',
		completionTime: 'Tiempo total',
		leaderboard: 'Clasificación',
		playAgain: 'Jugar de nuevo',
		done: 'Finalizar',
		home: 'Inicio',
		homeConfirm: '¿Volver al inicio? Este intento no se guardará.',
		bingoHomeConfirm: '¿Volver al inicio con una puntuación final de {score}?',
		returnHome: 'Volver al inicio',
		rank: 'Puesto',
		player: 'Jugador',
		score: 'Puntuación',
		survey: 'Unas preguntas antes de jugar',
		required: 'Este campo es obligatorio.',
		validEmail: 'Introduce una dirección de correo válida.',
		videoLoading: 'Cargando vídeo…',
		videoReveal: 'Mira el vídeo primero. La pregunta aparecerá en',
		videoError: 'No se pudo cargar el vídeo.',
		retryVideo: 'Reintentar vídeo',
		secondsLong: 'segundos.',
		selectAll: 'Selecciona todas las respuestas correctas.',
		rankHelp: 'Usa las flechas o arrastra las opciones para colocarlas en el orden correcto.',
		moveUp: 'Mover hacia arriba',
		moveDown: 'Mover hacia abajo',
		trueLabel: 'Verdadero',
		falseLabel: 'Falso',
		chooseOne: 'Elige una opción',
		iAgree: 'Acepto los',
		termsConditions: 'Términos y condiciones',
		viewDetails: 'Ver detalles',
		consentDetails: 'Detalles del consentimiento',
		close: 'Cerrar',
		bingoHelp: 'Elige una casilla. Las respuestas correctas marcan el tablero.',
		noResults: 'Todavía no hay resultados completados.',
		streak: 'racha',
		correctAnswer: 'Respuesta correcta',
	},
	fr: {
		loading: 'Chargement du jeu…',
		unavailable: 'Ce jeu n’est pas prêt',
		tryAgain: 'Réessayer',
		name: 'Votre nom',
		continue: 'Continuer',
		back: 'Retour',
		confirmTitle: 'Ces informations sont-elles correctes ?',
		confirmName: 'Nom',
		email: 'E-mail',
		edit: 'Modifier',
		start: 'Commencer',
		submit: 'Valider la réponse',
		next: 'Question suivante',
		correct: 'Bonne réponse !',
		incorrect: 'Pas tout à fait',
		hint: 'Indice',
		attemptsLeft: 'Essais restants',
		retryAnswer: 'Pas tout à fait. Réessayez.',
		timeExpired: 'Temps écoulé.',
		secondsShort: 'Sec',
		points: 'Points',
		headerLogin: 'Connexion',
		headerSurvey: 'Sondage',
		headerInstructions: 'Instructions',
		headerCategory: 'Catégorie',
		headerReveal: 'Révélation',
		headerBingo: 'Bingo',
		headerCategoryClash: 'Category Clash',
		headerLeaderboard: 'Classement',
		question: 'Question',
		of: 'sur',
		selectCategory: 'Choisissez une catégorie',
		revealCategory: 'Révéler une catégorie',
		yourCategory: 'Votre catégorie est',
		revealQuestion: 'Révéler la question',
		answerQuestion: 'Répondre à la question',
		flipCardTitle: 'Retournez une carte pour voir la catégorie',
		flipCardHelp: 'Chaque carte cache une catégorie. Choisissez bien.',
		spinCategoryTitle: 'Tournez pour une catégorie',
		spinCategoryHelp: 'Tournez la roue pour révéler votre catégorie.',
		pullCategoryTitle: 'Tirez pour une catégorie',
		pullCategoryHelp: 'Faites tourner le tambour pour révéler votre catégorie.',
		tapSpinCategory: 'Touchez Tourner pour révéler votre catégorie',
		spin: 'Tourner',
		category: 'Catégorie',
		chooseValue: 'Choisissez une valeur disponible dans cette catégorie.',
		continueRound: 'Continuer à jouer',
		endGame: 'Terminer le jeu',
		submitScoreEndGame: 'Envoyer le score et terminer',
		endConfirm: 'Terminer Category Clash avec votre score actuel ?',
		bingo: 'Bingo !',
		submitBingo: 'Valider le Bingo',
		submitBingoConfirm: 'Terminer cette grille de Bingo avec un score final de {score} ?',
		bonusPoints: 'Points bonus',
		bonusEarned: 'Points bonus gagnés :',
		bonusRules: 'Bonus :',
		perWinningPattern: 'par motif gagnant',
		fullBoardBonus: 'bonus de grille complète',
		bingoStreakBonusRule: 'Bonus de série : 2× les points pour la deuxième bonne réponse consécutive, 3× pour la troisième, puis une augmentation de 1×.',
		keepPlaying: 'Continuer à jouer',
		answered: 'Répondues',
		correctStat: 'Correctes',
		finalScore: 'Score final',
		correctAnswers: 'Bonnes réponses',
		completionTime: 'Temps total',
		leaderboard: 'Classement',
		playAgain: 'Rejouer',
		done: 'Terminer',
		home: 'Accueil',
		homeConfirm: 'Retourner à l’accueil ? Cette tentative ne sera pas enregistrée.',
		bingoHomeConfirm: 'Retourner à l’accueil avec un score final de {score} ?',
		returnHome: 'Retourner à l’accueil',
		rank: 'Rang',
		player: 'Joueur',
		score: 'Score',
		survey: 'Quelques questions avant de jouer',
		required: 'Ce champ est obligatoire.',
		validEmail: 'Saisissez une adresse e-mail valide.',
		videoLoading: 'Chargement de la vidéo…',
		videoReveal: 'Regardez d’abord la vidéo. La question apparaîtra dans',
		videoError: 'Impossible de charger la vidéo.',
		retryVideo: 'Réessayer la vidéo',
		secondsLong: 'secondes.',
		selectAll: 'Sélectionnez toutes les bonnes réponses.',
		rankHelp: 'Utilisez les flèches ou faites glisser les choix pour les placer dans le bon ordre.',
		moveUp: 'Déplacer vers le haut',
		moveDown: 'Déplacer vers le bas',
		trueLabel: 'Vrai',
		falseLabel: 'Faux',
		chooseOne: 'Choisissez une option',
		iAgree: 'J’accepte les',
		termsConditions: 'Conditions générales',
		viewDetails: 'Voir les détails',
		consentDetails: 'Détails du consentement',
		close: 'Fermer',
		bingoHelp: 'Choisissez une case. Les bonnes réponses marquent la grille.',
		noResults: 'Aucun résultat terminé pour le moment.',
		streak: 'série',
		correctAnswer: 'Bonne réponse',
	},
} as const;

export type TranslationKey = keyof typeof dictionaries.en;

export const translator = (language: Language) =>
	(key: TranslationKey): string => dictionaries[language][key] ?? dictionaries.en[key];
